import { route } from "react-router-typesafe-routes/dom";


export const CardLinkActivityRoutes = {
  CARDLINK_ACTIVITY: route("cardlink-activity", {}),
}